<template>
    <div class="news-detail" v-loading="loading">
      <div class="news-detail__header">
        <h1 class="news-detail__title">{{ article.title }}</h1>
        <div class="news-detail__meta">
          <span>{{ article.author }}</span>
          <template v-if="article.publishedTime">
            <span class="meta-divider">|</span>
            <span>发布于 {{ dateFormat(article.publishedTime) || '-' }}</span>
          </template>
          <template v-if="categoryText !== '-'">
            <span class="meta-divider">|</span>
            <span>{{ categoryText }}</span>
          </template>
          <template v-if="article.sourceName">
            <span class="meta-divider">|</span>
            <a class="news-detail__source" :href="article.sourceName" target="_blank">转载</a>
          </template>
        </div>
      </div>
      <el-divider />
      <!-- <div v-if="article.summary" class="news-detail__summary">
        <span class="summary-label">摘要</span>
        <p>{{ article.summary }}</p>
      </div> -->
      <div class="news-detail__content ql-editor" v-html="safeHtml" />
  
      <div v-if="article.attachments && article.attachments.length > 0" class="news-detail__attachments">
        <div class="attachments-title">
          <i class="el-icon-paperclip" />
          附件下载
        </div>
        <ul class="attachments-list">
          <li v-for="(file, index) in article.attachments" :key="index" class="attachment-item">
            <a href="javascript:void(0)" @click="handleDownload(file)">
              <i class="el-icon-document" />
              <span class="file-name">{{ file.fileName }}</span>
            </a>
          </li>
        </ul>
      </div>

      <el-divider />

      <div class="news-detail__nav">
        <div class="nav-item nav-prev" :class="{ 'nav-disabled': !article.prevNews }" @click="goToArticle(article.prevNews)">
          <template v-if="article.prevNews">
            <i class="el-icon-back" style="margin-right:6px;" />
            <div class="nav-info">
              <div class="nav-label">上一篇 </div>
              <span class="nav-title" style="margin-right:6px;">{{ article.prevNews.title }}</span>
            </div>
          </template>
        </div>
        <div class="nav-item nav-next" :class="{ 'nav-disabled': !article.nextNews }" @click="goToArticle(article.nextNews)">
          <template v-if="article.nextNews">
            <div class="nav-info">
              <div class="nav-label" style="text-align: right;">下一篇 </div>
              <span class="nav-title" style="text-align: right;">{{ article.nextNews.title }}</span>
            </div>
            <i class="el-icon-right" style="margin-left:6px;" />
          </template>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import DOMPurify from 'dompurify'
  import { getNewsInfo, downloadOss } from '@/api/news'
  import { checkPay } from '@/api/basic'
  import { decrypt } from '@/utils/crypto'
  import '@/assets/news-detail.css'
  import '@/assets/quill-content.css'

  export default {
    name: "NewsLayoutView",
    data() {
      return {
        article: {},
        loading: false
      };
    },
    computed: {
      categoryText() {
        if (!this.article) {
          return '-'
        }
        if (this.article.categoryNames && this.article.categoryNames.length) {
          return this.article.categoryNames.join('、')
        }
        return this.article.categoryNames || '-'
      },
      safeHtml() {
        // 核心：先净化，再渲染
        return DOMPurify.sanitize(this.article.content||'')
      }
    },
    watch: {},
    created() { 
        this.init()
     },
    methods: {
        async init() {
            const feePhone = this.$route.query.p // 付费文章需要路由携带手机号信息-加密形式
            const id = this.$route.params.id // 文章id
            
            if (feePhone) {
              // 是否存在付费手机号
                const encryptedPhone = this.$route.query.p
                if (!encryptedPhone) {
                    this.showPayAlert()
                    return
                }
                const phone = decrypt(encryptedPhone)
                if (!phone) {
                    this.showPayAlert()
                    return
                }
                const payRes = await checkPay({ phone, url: this.$route.path })
                if (payRes.data.resultCode == '200' && payRes.data.data.status == 1) {
                  // 已付费
                  this.loading = true
                  const res = await getNewsInfo(id).finally(() => {
                      this.loading = false
                  })
                  const article = res.data
                  this.article = article
                  return
                }
                // 非付费给出提示文字
                this.showPayAlert()
                return
            }else {
              // 不存在付费手机号，在详情中获取文章信息
              this.loading = true
              const res = await getNewsInfo(id).finally(() => {
                  this.loading = false
              })
              const article = res.data
              if(article.categories && article.categories.includes('dry_goods_sharing')) {
                // 付费文章，给出提示从列表进入
                this.showPayAlert()
                return
              }
              // 免费文章
              this.article = article
            }
        },
        showPayAlert() {
            this.$alert('该文章需付费后查看，请从相关咨询页面点击进入查看，如果已付费请重新输入手机号验证', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                    this.$router.replace('/pc/news?tabIndex=4')
                }
            })
        },
        goToArticle(news) {
            if (!news) return
            this.$router.push({ name: 'NewsLayoutView', params: { id: news.id } })
            this.init()
        },
        async handleDownload(file) {
            // 有 ossId 时走接口下载文件流
            const ossId = file.ossId || file.ossID || file.oss_id
            if (ossId) {
                try {
                    const res = await downloadOss(ossId)
                    const blob = res.data
                    // 如果返回的不是 Blob（可能是后端返回的 JSON 错误），直接提示
                    if (!(blob instanceof Blob)) {
                        this.$message && this.$message.error('下载失败，请稍后重试')
                        return
                    }
                    // JSON 错误兜底：后端异常时可能返回 JSON Blob
                    if (blob.type && blob.type.includes('application/json')) {
                        const text = await blob.text()
                        try {
                            const err = JSON.parse(text)
                            this.$message && this.$message.error(err.msg || '下载失败')
                        } catch (_) {
                            this.$message && this.$message.error('下载失败')
                        }
                        return
                    }
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = file.fileName || 'download'
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    window.URL.revokeObjectURL(url)
                } catch (e) {
                    this.$message && this.$message.error('下载失败，请稍后重试')
                }
                return
            }
            // 无 ossId 时直接通过 fileUrl 下载
            if (file.fileUrl) {
                const a = document.createElement('a')
                a.href = file.fileUrl
                a.target = '_blank'
                if (file.fileName) a.download = file.fileName
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
        },
        // 处理日期显示
        dateFormat(date) {
          if(!date) return '' 
          return date.substring(0, 10)
        },
    },
  };
  </script>
  
  <style scoped>


  .news-detail__nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  .nav-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
  }
  .nav-item:hover {
    color:#409eff;
  }
  .nav-item i {
    color:#409eff;
  }
  .nav-label {
    color:#999;
    margin-bottom: 5px;
  }
  .nav-title {
    display: inline-block;
    width: 24em;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-detail__source {
    background-color: #eff6fc;
    color: #409eff;
    border: 1px solid #eff6fc;
    border-radius: 4px;
    padding: 0 4px;
    font-size: 13px;
  }
  @media screen and (max-width: 768px) {
    .nav-title {
      width: 8em;
    }
  }
  </style>